import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=e6a90994&scoped=true"
import script from "./Instruction.vue?vue&type=script&lang=ts"
export * from "./Instruction.vue?vue&type=script&lang=ts"
import style0 from "./Instruction.vue?vue&type=style&index=0&id=e6a90994&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a90994",
  null
  
)

export default component.exports